var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserBlank = function SvgUserBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 0C6.272 0 0 6.272 0 14s6.272 14 14 14 14-6.272 14-14S21.728 0 14 0m0 5.6c2.702 0 4.9 2.198 4.9 4.9s-2.198 4.9-4.9 4.9a4.905 4.905 0 0 1-4.9-4.9c0-2.702 2.198-4.9 4.9-4.9m0 19.6c-2.842 0-6.202-1.148-8.596-4.032a13.926 13.926 0 0 1 17.192 0C20.202 24.052 16.842 25.2 14 25.2"
  })));
};
export default SvgUserBlank;